<template>
  <b-form>
    <div class="row mb-1 pb-3 mb-3 border-bottom g-0" style="--bs-border-color: black">
      <div class="col-md-12 d-flex align-items-center">
        <span class="fw-bold">Realisasi Pemanfaatan Ruang Laut</span>
      </div>
    </div>

    <legend v-if="jenis_kegiatan === 'Berusaha'" class="fw-bold text-gray">
      Realisasi luas/panjang pemanfaatan ruang laut, dalam hal perizinan berusaha yang diterbitkan
    </legend>
    <legend v-if="jenis_kegiatan === 'Non Berusaha'" class="fw-bold text-gray">
      Realisasi luas/panjang pemanfaatan ruang laut, dalam hal perizinan non berusaha yang diterbitkan
    </legend>
    <div :class="['row mb-3']">
      <div class="col-md-6 mt-3">
        <div class="row">
          <div class="col">
            <label>Luas <span class="text-danger">*</span></label>
            <i class="fa fa-info-circle ml-1" v-b-tooltip.hover.topright="'Jika tidak ada isi dengan 0'" />
            <div class="input-units">
              <b-form-input
                v-model="form.luas"
                id="luas"
                v-mask="decimalMask(form.luas)"
                v-validate="'required'"
                name="Luas/Panjang"
                :class="{
                  input: true,
                  'is-danger': errors.has('Luas/Panjang'),
                }"
                :disabled="is_selesai"
                style="background-color: white"
              ></b-form-input>
              <div class="text-units">
                <span>{{ form.luas }}</span>
                <span> ha</span>
              </div>
            </div>
            <span class="text-danger" v-if="errors.has('Luas/Panjang')">
              {{ errors.first('Luas/Panjang') }}
            </span>
          </div>
          <div class="col">
            <label>Panjang <span class="text-danger">*</span></label>
            <i class="fa fa-info-circle ml-1" v-b-tooltip.hover.topright="'Jika tidak ada isi dengan 0'" />
            <div class="input-units">
              <b-form-input
                v-model="form.panjang"
                id="panjang"
                v-mask="decimalMask(form.panjang)"
                v-validate="'required'"
                name="Luas/Panjang"
                :class="{
                  input: true,
                  'is-danger': errors.has('Luas/Panjang'),
                }"
                :disabled="is_selesai"
                style="background-color: white"
              ></b-form-input>
              <div class="text-units">
                <span>{{ form.panjang }}</span>
                <span> km</span>
              </div>
            </div>
            <span class="text-danger" v-if="errors.has('Luas/Panjang')">
              {{ errors.first('Luas/Panjang') }}
            </span>
          </div>
        </div>
      </div>
      <div class="col-md-6 mt-3">
        <label>Kedalaman <span class="text-danger">*</span></label>
        <div class="input-units">
          <b-form-input
            v-model="form.kedalaman"
            id="kedalaman"
            v-mask="decimalMask(form.kedalaman)"
            v-validate="'required'"
            name="Kedalaman"
            :class="{
              input: true,
              'is-danger': errors.has('Kedalaman'),
            }"
            :disabled="is_selesai"
            style="background-color: white"
          ></b-form-input>
          <div class="text-units">
            <span>{{ form.kedalaman }}</span>
            <span> m</span>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Kedalaman')">
          {{ errors.first('Kedalaman') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Provinsi <span class="text-danger">*</span></label>
        <v-select
          v-model="selectedProvinsi"
          id="provinsi"
          :reduce="(data) => data.nama_provinsi"
          label="nama_provinsi"
          :options="dataProvinsi"
          multiple
          name="Provinsi"
          v-validate="'required'"
          @input="selectProvinsi"
          :class="{
            input: true,
            'pe-none': is_selesai,
            'is-danger': errors.has('Provinsi'),
          }"
        />
        <span class="text-danger" v-if="errors.has('Provinsi')">
          {{ errors.first('Provinsi') }}
        </span>
      </div>
      <div v-if="!is_laut_12mil" class="col-md-6 mt-3">
        <label>Kabupaten <span class="text-danger">*</span></label>
        <v-select
          id="kabupaten"
          v-model="form.kabupaten"
          :reduce="(data) => data.nama_kabupaten"
          label="nama_kabupaten"
          :options="dataKabupaten"
          name="Kabupaten"
          v-validate="'required'"
          @input="selectKabupaten"
          :class="{
            input: true,
            'pe-none': is_selesai,
            'is-danger': errors.has('Kabupaten'),
          }"
        />
        <span class="text-danger" v-if="errors.has('Kabupaten')">
          {{ errors.first('Kabupaten') }}
        </span>
      </div>
      <div v-if="!is_laut_12mil" class="col-md-6 mt-3">
        <label>Kecamatan <span class="text-danger">*</span></label>
        <v-select
          id="kecamatan"
          v-model="form.kecamatan"
          :reduce="(data) => data.nama_kecamatan"
          label="nama_kecamatan"
          :options="dataKecamatan"
          name="Kecamatan"
          v-validate="'required'"
          @input="selectKecamatan"
          :class="{
            input: true,
            'pe-none': is_selesai,
            'is-danger': errors.has('Kecamatan'),
          }"
        />
        <span class="text-danger" v-if="errors.has('Kecamatan')">
          {{ errors.first('Kecamatan') }}
        </span>
      </div>
      <div v-if="!is_laut_12mil" class="col-md-6 mt-3">
        <label>Desa/Kelurahan <span class="text-danger">*</span></label>
        <b-form-input
          name="Desa/Kelurahan"
          v-model="form.kelurahan"
          id="desa_kelurahan"
          v-validate="'required'"
          :class="{
            input: true,
            'is-danger': errors.has('Detail Kegiatan'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Desa/Kelurahan')">
          {{ errors.first('Desa/Kelurahan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Nama Perairan/Laut <span class="text-danger">*</span></label>
        <b-form-input
          name="Nama Perairan/Laut"
          v-validate="'required'"
          v-model="form.nama_perairan"
          id="nama_perairan"
          :class="{
            input: true,
            'is-danger': errors.has('Detail Kegiatan'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Nama Perairan/Laut')">
          {{ errors.first('Nama Perairan/Laut') }}
        </span>
      </div>
      <div v-if="jenis_kegiatan === 'Berusaha'" class="col-md-6 mt-3">
        <label>Kode KBLI <span class="text-danger">*</span></label>
        <v-select
          v-model="selectedKBLI"
          id="kode_kbli"
          :reduce="(data) => data.kode"
          label="kode_deskripsi"
          :options="dataKBLI"
          multiple
          name="Kode KBLI"
          v-validate="'required'"
          :class="{
            input: true,
            'pe-none': is_selesai,
            'is-danger': errors.has('Kode KBLI'),
          }"
        />
        <span class="text-danger" v-if="errors.has('Kode KBLI')">
          {{ errors.first('Kode KBLI') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Detail Kegiatan {{ jenis_kegiatan }} <span class="text-danger">*</span></label>
        <b-form-input
          v-model="form.detail_kegiatan"
          id="detail_kegiatan"
          v-validate="'required'"
          name="Detail Kegiatan"
          :class="{
            input: true,
            'is-danger': errors.has('Detail Kegiatan'),
          }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Detail Kegiatan')">
          {{ errors.first('Detail Kegiatan') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label>Reklamasi <span class="text-danger">*</span></label>
        <v-select
          id="reklamasi"
          v-model="form.reklamasi"
          :reduce="(data) => data.value"
          label="label"
          :options="[
            { label: 'Ya', value: true },
            { label: 'Tidak', value: false },
          ]"
          name="Reklamasi"
          v-validate="'required'"
          :class="{
            input: true,
            'pe-none': is_selesai,
            'is-danger': errors.has('Reklamasi'),
          }"
        />
        <span class="text-danger" v-if="errors.has('Reklamasi')">
          {{ errors.first('Reklamasi') }}
        </span>
      </div>
      <div class="col-md-6 mt-3">
        <label for="waktu_realisasi" class="m-0">
          Waktu Realisasi
          <span class="text-danger">*</span>
        </label>
        <b-form-input
          type="date"
          v-model="form.waktu_realisasi"
          id="waktu_realisasi"
          v-validate="'required'"
          name="Waktu Realisasi"
          :class="{ input: true, 'is-danger': errors.has('Waktu Realisasi') }"
          :disabled="is_selesai"
          style="background-color: white"
        ></b-form-input>
        <span class="text-danger" v-if="errors.has('Waktu Realisasi')">
          {{ errors.first('Waktu Realisasi') }}
        </span>
      </div>
    </div>
    <div class="row mb-1 pb-3 border-bottom g-0"></div>

    <div class="row">
      <div class="col-4 col-xl-5 mt-3">
        <span>Koordinat</span>
      </div>
      <div class="col-8 col-xl-7 mt-3">
        <div class="row">
          <div>
            <small>Format file: XLSX, Ukuran maksimal: 5MB <span class="text-danger">*</span></small>
          </div>
          <div class="col-4">
            <b-form-file
              v-model="form.file_kordinat"
              id="file_kordinat"
              plain
              class="form-control"
              name="Koordinat"
              accept=".xls, .xlsx"
              @change="
                (e) => {
                  checkFileSize(e, 'file_kordinat')
                  errors.remove('Koordinat')
                }
              "
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-8 d-flex">
            <a
              :class="{
                'btn btn-success': true,
                disabled: !id_file_kordinat,
              }"
              @click="unduhFileExcel(id_file_kordinat)"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
            <a
              v-if="!is_selesai"
              class="btn btn-info mr-2 text-white ml-2"
              :href="'https://backend-sea.kkp.go.id/pengendalian/template/format_import_kordinat.xlsx'"
            >
              <i class="fa fa-file-o"></i> Template
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Koordinat')">
          {{ errors.first('Koordinat') }}
        </span>
        <span class="text-danger" v-if="errors.has('file_kordinat', 'custom')">
          {{ errors.first('file_kordinat', 'custom') }}
        </span>
      </div>
      <div class="col-4 col-xl-5 mt-3">
        <span>Dokumentasi kegiatan bangungan/instalasi di lokasi</span>
      </div>
      <div class="col-8 col-xl-7 mt-3">
        <div class="row">
          <div>
            <small>Format file: PDF, Ukuran maksimal: 5MB <span class="text-danger">*</span></small>
          </div>
          <div class="col-4">
            <b-form-file
              v-model="form.file_dokumentasi_kegiatan_bangunan"
              id="file_dokumentasi_kegiatan_bangunan"
              plain
              class="form-control"
              name="Dokumentasi Kegiatan"
              accept=".pdf"
              @change="
                (e) => {
                  checkFileSize(e, 'file_dokumentasi_kegiatan_bangunan')
                  errors.remove('Dokumentasi Kegiatan')
                }
              "
              :disabled="is_selesai"
            ></b-form-file>
          </div>
          <div class="col-8 d-flex">
            <a
              :class="{
                'btn btn-success': true,
                disabled: !id_file_dokumentasi_kegiatan_bangunan,
              }"
              @click="unduhFile(id_file_dokumentasi_kegiatan_bangunan)"
            >
              <i class="fa fa-download" />
              Unduh
            </a>
          </div>
        </div>
        <span class="text-danger" v-if="errors.has('Dokumentasi Kegiatan')">
          {{ errors.first('Dokumentasi Kegiatan') }}
        </span>
        <span class="text-danger" v-if="errors.has('file_dokumentasi_kegiatan_bangunan', 'custom')">
          {{ errors.first('file_dokumentasi_kegiatan_bangunan', 'custom') }}
        </span>
      </div>
    </div>

    <div class="mt-5 fw-bold">Note: tanda (<span class="text-danger">*</span>) wajib diisi</div>
  </b-form>
</template>

<script>
import vSelect from 'vue-select'
import { decimalMask } from '../../../helper/validationHelper'
import Swal from 'sweetalert2'
import DatePicker from 'vue2-datepicker'
import { formatDate } from '../../../helper/helpernew'
import api from '@/services/api'
import { isReadonlyStatus } from './statusRencanaAksi'

export default {
  components: {
    vSelect,
    DatePicker,
  },
  data() {
    return {
      form: {
        luas: '0',
        panjang: '0',
        kedalaman: '0',
        provinsi: '',
        kabupaten: '',
        kecamatan: '',
        kelurahan: '',
        nama_perairan: '',
        kode_kbli: '',
        detail_kegiatan: '',
        reklamasi: '',
        waktu_realisasi: '',
        file_kordinat: null,
        file_dokumentasi_kegiatan_bangunan: null,
      },
      dataPerizinan: {
        jenis_kegiatan: '',
        nomor_kkprl: '',
        luas: '0',
        panjang: '0',
        kedalaman: '0',
        provinsi: '',
        kabupaten: '',
        kecamatan: '',
        kelurahan: '',
        nama_perairan: '',
        kode_kbli: '',
        detail_kegiatan: '',
        reklamasi: '',
        waktu_realisasi: '',
      },
      is_selesai: false,
      id_persiapan_penilaian: null,
      id_file_kordinat: null,
      id_file_dokumentasi_kegiatan_bangunan: null,
      jenis_kegiatan: null,
      selectedProvinsi: [],
      selectedKBLI: [],
      dataProvinsi: [],
      dataKabupaten: [],
      dataKecamatan: [],
      dataKBLI: [],
      dataKegiatan: [
        { value: 1, text: 'Berusaha' },
        { value: 0, text: 'Non Berusaha' },
      ],
      is_laut_12mil: true,
    }
  },
  inject: ['setIsSelesai'],
  async mounted() {
    await this.getProvinsi()
    await this.getKBLI()
    this.loadData()
  },
  methods: {
    decimalMask,
    formatDate,

    async resolveIdPersiapanPenilaian() {
      const existing = this.$route.query.id_persiapan_penilaian
      if (existing) return existing

      const id_rencana_aksi = this.$route.query.id_rencana_aksi
      if (!id_rencana_aksi) return null

      const res = await api.get(`api/persiapan_penilaian?filter=id_rencana_aksi,=,${id_rencana_aksi}`)
      const data = res.data?.data?.[0]
      if (!data?.id) return null

      await this.$router
        .replace({ path: this.$route.path, query: { ...this.$route.query, id_persiapan_penilaian: data.id } })
        .catch(() => {})
      return data.id
    },

    async loadData() {
      const id = await this.resolveIdPersiapanPenilaian()
      if (!id) {
        await this.loadLaporanTahunan()
        return
      }
      this.id_persiapan_penilaian = id

      let data = null
      this.$loading(true)
      try {
        const res = await api.get(`api/persiapan_penilaian/${id}`)
        data = res.data?.data
      } catch (error) {
        data = null
      } finally {
        this.$loading(false)
      }

      if (data) {
        this.is_selesai = isReadonlyStatus(data.status)
        this.setIsSelesai(this.is_selesai)
      }

      // provinsi falsy => tab realisasi pemanfaatan ruang laut belum diisi
      if (data && data.provinsi) {
        await this.applyPersiapanPenilaian(data)
      } else {
        await this.loadLaporanTahunan()
      }
    },

    async applyPersiapanPenilaian(data) {
      this.jenis_kegiatan = data.jenis_kegiatan || null

      this.form = {
        ...this.form,
        luas: data.realisasi_luas != null ? String(data.realisasi_luas) : '0',
        panjang: data.realisasi_panjang != null ? String(data.realisasi_panjang) : '0',
        kedalaman: data.kedalaman != null ? String(data.kedalaman) : '0',
        kabupaten: data.kabupaten || '',
        kecamatan: data.kecamatan || '',
        kelurahan: data.kelurahan || '',
        nama_perairan: data.nama_perairan || '',
        detail_kegiatan: data.detail_kegiatan || '',
        reklamasi: data.reklamasi != null ? data.reklamasi : false,
        waktu_realisasi: data.waktu_realisasi || '',
        file_kordinat: null,
        file_dokumentasi_kegiatan_bangunan: null,
      }
      this.id_file_kordinat = data.id_file_kordinat || null
      this.id_file_dokumentasi_kegiatan_bangunan = data.id_file_dokumentasi_kegiatan_bangunan || null

      if (data.provinsi && data.provinsi.length > 0) {
        this.selectedProvinsi = data.provinsi
        if (data.provinsi[0] === 'Laut di atas 12 mil') {
          this.is_laut_12mil = true
        } else {
          this.is_laut_12mil = false
          await this.loadLocation()
        }
      }
      this.selectedKBLI = data.kode_kbli || []
    },

    async nextForm() {
      this.errors.clear()
      if (this.is_selesai) return true

      this.form.provinsi = this.multipleSelectToString(this.selectedProvinsi)
      this.form.kode_kbli = this.multipleSelectToString(this.selectedKBLI)

      if (!this.id_file_kordinat && !this.form.file_kordinat) {
        this.errors.add({ field: 'Koordinat', msg: 'File Koordinat wajib diisi' })
      }
      if (!this.id_file_dokumentasi_kegiatan_bangunan && !this.form.file_dokumentasi_kegiatan_bangunan) {
        this.errors.add({ field: 'Dokumentasi Kegiatan', msg: 'File Dokumentasi Kegiatan wajib diisi' })
      }

      if (!(await this.$validator.validateAll()) || this.errors.any()) return false

      this.id_persiapan_penilaian = this.id_persiapan_penilaian || (await this.resolveIdPersiapanPenilaian())
      if (!this.id_persiapan_penilaian) {
        Swal.fire('Gagal', 'Lengkapi tab Identitas terlebih dahulu', 'error')
        return false
      }

      this.$loading(true)
      try {
        const formData = new FormData()
        // prettier-ignore
        {
          formData.append('realisasi_luas', parseFloat(this.form.luas))
          formData.append('realisasi_panjang', parseFloat(this.form.panjang))
          formData.append('kedalaman', parseFloat(this.form.kedalaman))
          formData.append('provinsi', this.form.provinsi)
          formData.append('kabupaten', this.form.kabupaten)
          formData.append('kecamatan', this.form.kecamatan)
          formData.append('kelurahan', this.form.kelurahan)
          formData.append('nama_perairan', this.form.nama_perairan)
          if (this.jenis_kegiatan === 'Berusaha') {
            formData.append('kode_kbli', this.form.kode_kbli)
          }
          formData.append('detail_kegiatan', this.form.detail_kegiatan)
          formData.append('reklamasi', this.form.reklamasi)
          formData.append('waktu_realisasi', this.form.waktu_realisasi)
          if (this.form.file_kordinat) {
            formData.append('file_kordinat', this.form.file_kordinat)
          } else if (this.id_file_kordinat) {
            formData.append('id_file_kordinat', this.id_file_kordinat)
          }
          if (this.form.file_dokumentasi_kegiatan_bangunan) {
            formData.append('file_dokumentasi_kegiatan_bangunan', this.form.file_dokumentasi_kegiatan_bangunan)
          } else if (this.id_file_dokumentasi_kegiatan_bangunan) {
            formData.append('id_file_dokumentasi_kegiatan_bangunan', this.id_file_dokumentasi_kegiatan_bangunan)
          }
        }

        const res = await api.post(`api/persiapan_penilaian/${this.id_persiapan_penilaian}`, formData)
        const saved = res.data?.data
        if (saved?.id_file_kordinat) {
          this.id_file_kordinat = saved.id_file_kordinat
          this.form.file_kordinat = null
        }
        if (saved?.id_file_dokumentasi_kegiatan_bangunan) {
          this.id_file_dokumentasi_kegiatan_bangunan = saved.id_file_dokumentasi_kegiatan_bangunan
          this.form.file_dokumentasi_kegiatan_bangunan = null
        }

        Swal.fire('Berhasil', 'Realisasi Pemanfaatan Ruang Laut tersimpan', 'success')
        return true
      } catch (error) {
        const message = error.response?.data?.message || 'Terjadi kesalahan saat menyimpan data'
        Swal.fire('Gagal', message, 'error')
        return false
      } finally {
        this.$loading(false)
      }
    },

    async loadLaporanTahunan() {
      if (!this.$route.query.id_laporan) {
        return
      }

      this.$loading(true)
      return api
        .get(`api/laporan_tahunan/${this.$route.query.id_laporan}`)
        .then(async (res) => {
          const data = res.data.data

          this.dataPerizinan = {
            ...this.dataPerizinan,
            jenis_kegiatan: data.jenis_kegiatan,
            nomor_kkprl: data.nomor_kkprl,
          }

          await this.loadPerizinan()

          this.jenis_kegiatan = data.jenis_kegiatan
          // this.is_selesai =
          //   data.status_laporan !== null &&
          //   data.status_laporan !== 'Draft' &&
          //   data.status_laporan !== 'Komentar/Informasi terhadap Penyampaian Laporan Tahunan'
          const perizinan = this.dataPerizinan

          this.form = {
            luas: data.realisasi_luas || perizinan.luas || '0',
            panjang: data.realisasi_panjang || '0',
            kedalaman: data.kedalaman || perizinan.kedalaman || '0',
            kabupaten: data.kabupaten || perizinan.kabupaten || '',
            kecamatan: data.kecamatan || perizinan.kecamatan || '',
            kelurahan: data.kelurahan || perizinan.kelurahan || '',
            nama_perairan: data.nama_perairan || perizinan.nama_perairan || '',
            detail_kegiatan: data.detail_kegiatan || perizinan.detail_kegiatan || '',
            reklamasi: data.reklamasi || perizinan.reklamasi || false,
            waktu_realisasi: data.waktu_realisasi || '',
            file_kordinat: null,
            file_dokumentasi_kegiatan_bangunan: null,
          }
          this.id_file_kordinat = data.id_file_kordinat
          this.id_file_dokumentasi_kegiatan_bangunan = data.id_file_dokumentasi_kegiatan_bangunan
          if (data.provinsi && data.provinsi.length > 0) {
            this.selectedProvinsi = data.provinsi
            if (data.provinsi[0] === 'Laut di atas 12 mil') {
              this.is_laut_12mil = true
            } else {
              this.is_laut_12mil = false
              this.loadLocation()
            }
          }
          this.selectedKBLI = data.kode_kbli || []
        })
        .catch((err) => {
          Swal.fire('Gagal', 'Terjadi kesalahan saat mengambil data', 'error')
        })
        .finally(() => {
          this.$loading(false)
        })
    },

    async loadPerizinan() {
      const nomor_kkprl = this.dataPerizinan.nomor_kkprl
      let resData = {}
      if (this.dataPerizinan.jenis_kegiatan === 'Berusaha') {
        const res = await api.get(`api/ref/getPermohonan/Berusaha?filter=nomor_oss,=,${nomor_kkprl}`)
        resData = res.data.data[0]
        if (!resData) return
      } else {
        const res = await api.get(`api/ref/getPermohonan/Nonberusaha?filter=nomor_kkp,=,${nomor_kkprl}`)
        resData = res.data.data[0]
        if (!resData) return
      }

      this.selectedProvinsi = [resData.provinsi]
      this.selectedKBLI = resData.kbli
      this.dataPerizinan = {
        ...this.form,
        ...this.dataPerizinan,
        luas: resData.luas,
        panjang: '0',
        kedalaman: resData.kedalaman,
        kabupaten: resData.kabupaten,
        kecamatan: resData.kecamatan,
        kelurahan: '',
        nama_perairan: resData.nama_perairan,
        detail_kegiatan: resData.rencana_detail_kegiatan,
        reklamasi: resData.reklamasi,
        waktu_realisasi: resData.waktu_realisasi,
      }
    },

    async loadLocation() {
      const provinsi = this.selectedProvinsi[0]
      const fProvinsi = this.dataProvinsi.find((dd) => dd.nama_provinsi === provinsi)
      if (!fProvinsi) return

      await this.getKabupaten(fProvinsi.id)
      const kabupaten = this.form.kabupaten
      const fKabupaten = this.dataKabupaten.find((dd) => dd.nama_kabupaten === kabupaten)
      if (!fKabupaten) return

      await this.getKecamatan(fKabupaten.id)
    },

    selectProvinsi(d) {
      const find = this.dataProvinsi.find((dd) => dd.nama_provinsi === d[0])
      if (find && find.id === 0) {
        this.is_laut_12mil = true
      } else {
        this.is_laut_12mil = false
      }
      if (find && find.id) this.getKabupaten(find.id)
      this.form.kabupaten = ''
      this.form.kecamatan = ''
      this.form.kelurahan = ''
    },

    selectKabupaten(d) {
      const find = this.dataKabupaten.find((dd) => dd.nama_kabupaten === d)
      if (find) this.getKecamatan(find.id)
      this.form.kecamatan = ''
      this.form.kelurahan = ''
    },

    selectKecamatan() {
      this.form.kelurahan = ''
    },

    async getProvinsi() {
      await api.get('api/provinsi?sort=id,ASC&limit=0').then((response) => {
        const exc = ['Pusat']
        this.dataProvinsi = response.data.data.filter((d) => {
          return !exc.includes(d.nama_provinsi)
        })
      })
    },

    async getKabupaten(id_provinsi) {
      await api.get(`api/kabupaten?sort=id,ASC&limit=0&filter=id_provinsi,=,${id_provinsi}`).then((response) => {
        this.dataKabupaten = response.data.data
      })
    },

    async getKecamatan(id_kabupaten) {
      await api.get(`api/kecamatan?sort=id,ASC&limit=0&filter=id_kabupaten,=,${id_kabupaten}`).then((response) => {
        this.dataKecamatan = response.data.data
      })
    },

    async getKBLI() {
      await api.get('api/kbli?limit=0').then((response) => {
        this.dataKBLI = response.data.data
      })
    },

    multipleSelectToString(data) {
      let str = ''
      for (let i = 0; i < data.length; i++) {
        if (i !== 0) str += '||'
        str += data[i]
      }
      return str
    },

    checkFileSize(e, field) {
      const file = e.target.files[0]
      const maxSize = 5 * 1024 * 1024

      if (file && file.size > maxSize) {
        this.errors.add({
          field: field,
          msg: 'Ukuran file maksimal 5MB',
          scope: 'custom',
        })
        this.form[field] = null
        e.target.value = null
      } else {
        this.errors.remove(field, 'custom')
      }
    },

    async unduhFile(id) {
      const res = await api.get(`api/files/download/${id}`, { responseType: 'blob' })
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      window.open(fileURL, '_blank')
    },

    async unduhFileExcel(id) {
      const { nomor_kkprl } = this.dataPerizinan
      const res = await api.get(`api/files/download/${id}`, { responseType: 'blob' })
      const res2 = await api.get(`api/files?filter=id,=,${id}`)
      const ext = res2.data.data[0].file_name.split('.').pop()
      const file = new Blob([res.data], { type: res.data.type })
      const fileURL = URL.createObjectURL(file)
      const a = document.createElement('a')
      a.href = fileURL
      a.download = `Koordinat_${nomor_kkprl}.${ext}`
      document.body.appendChild(a)
      a.click()
      a.remove()
      URL.revokeObjectURL(fileURL)
    },
  },
  watch: {},
}
</script>
